<form *ngIf="acmForm" id="campaign-acm-form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="acmForm" (ngSubmit)="save()" RestrictFocus>
  <div class="ui-grid ui-grid-responsive ui-fluid" >
    <!-- Canale -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !acm}">
          {{ 'common.storeChannelLoyalty' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown  (onChange)="getAcmList()" [filter]="true" [options]="channelList" formControlName="channelCode" [style]="{ width: '100%' }" [disabled]="!!acm"></p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && acmForm.controls['channelCode'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Tipo Acm -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !acm}">
          {{ 'acm_type.acmType' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown (onChange)="getAcmList()" [filter]="true" [options]="acmTypeList" formControlName="acmType" [style]="{ width: '100%' }" [disabled]="!!acm"></p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && acmForm.controls['acmType'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Acm -->
    <div class="ui-grid-row bottom-10-margin" *ngIf="!acm" >
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !acm}">
          {{ 'common.acm' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown (onChange)="setAcmData($event.value)" [filter]="true" [options]="acmList" formControlName="acm" [style]="{ width: '100%' }" [disabled]="acmFieldDisabled"></p-dropdown>
        <span class="input-error-notification" *ngIf="invalidSubmit && acmForm.controls['acm'].errors?.required">{{ 'common.required_error' | translate }}</span>
      </div>
    </div>
    <!-- Data Inizio -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'common.date_start' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="text" formControlName="dateStart" [style]="{ width: '100%' }" disabled>
      </div>
    </div>
    <!-- Data Fine -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'common.date_end' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="text" formControlName="dateEnd" [style]="{ width: '100%' }" disabled>
      </div>
    </div>
    <!-- Codice Acm -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'campaign.acmCode' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="text" formControlName="acmCode" [style]="{ width: '100%' }" disabled>
      </div>
    </div>
    <!-- Nome Acm -->
    <div class="ui-grid-row bottom-10-margin" *ngIf="acm">
      <div class="ui-grid-col-4">
        <label [ngClass]="{'required': !acm}">
          {{ 'campaign.acmName' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="text" formControlName="acmName" [style]="{ width: '100%' }" disabled>
      </div>
    </div>
    <!-- Tipo Operazione -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'campaign.operationType' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown *ngIf="operationTypeList && operationTypeList.length > 0" [options]="operationTypeList" [(ngModel)]="operationTypeElement"  formControlName="operationType" [style]="{ width: '100%' } " ></p-dropdown>
      </div>
    </div>
    <!-- Valore -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'customers.value' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="number" formControlName="value" [style]="{ width: '100%' }">
      </div>
    </div>
    <!-- Espressione -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'campaign.expression' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <input pInputText type="text" formControlName="exp" [style]="{ width: '100%' }">
      </div>
    </div>
    <!-- Scope Accumulatore -->
    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4">
        <label>
          {{ 'campaign.acmScope' | translate }}
        </label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown [options]="acmScopeList" formControlName="scope" [style]="{ width: '100%' }" ></p-dropdown>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0;">
      <button
        class="k-generic-btn"
        type="submit"
        pButton
        icon="fa fa-check"
        label="{{'common.save' | translate }}">
      </button>
    </div>
  </p-footer>
</form>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-accumulators/campaign-accumulators-form/campaign-accumulators-form.component.html